import { SvgIcon } from "@mui/material";
import React from "react";

export default function DealerAvatarIcon({ ...props }: any) {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        {...props}
      >
        <path
          d="M18.5 21.0449V19.0449C18.5 18.1167 18.131 17.2267 17.4746 16.5703C16.8593 15.955 16.0388 15.5918 15.1738 15.5488L15 15.5449H9C8.07174 15.5449 7.18177 15.9139 6.52539 16.5703C5.86901 17.2267 5.5 18.1167 5.5 19.0449V21.0449C5.5 21.3211 5.27614 21.5449 5 21.5449C4.72386 21.5449 4.5 21.3211 4.5 21.0449V19.0449C4.5 17.8514 4.97445 16.7072 5.81836 15.8633C6.66227 15.0194 7.80653 14.5449 9 14.5449H15C16.1935 14.5449 17.3377 15.0194 18.1816 15.8633C19.0256 16.7072 19.5 17.8514 19.5 19.0449V21.0449C19.5 21.3211 19.2761 21.5449 19 21.5449C18.7239 21.5449 18.5 21.3211 18.5 21.0449Z"
          // fill="white"
        />
        <path
          d="M15.5 7.04492C15.5 5.11193 13.933 3.54492 12 3.54492C10.067 3.54492 8.5 5.11193 8.5 7.04492C8.5 8.97792 10.067 10.5449 12 10.5449C13.933 10.5449 15.5 8.97792 15.5 7.04492ZM16.5 7.04492C16.5 9.5302 14.4853 11.5449 12 11.5449C9.51472 11.5449 7.5 9.5302 7.5 7.04492C7.5 4.55964 9.51472 2.54492 12 2.54492C14.4853 2.54492 16.5 4.55964 16.5 7.04492Z"
          // fill="white"
        />
      </svg>
    </SvgIcon>
  );
}
